import {stopQuagga} from "../../public/js/stopScanner-v2";

require('./bootstrap');
// import 'tw-elements';
import Alpine from 'alpinejs';
import mask from '@alpinejs/mask';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';
import collapse from '@alpinejs/collapse';
import Lightbox from '@edsardio/alpine-lightbox';
import {hasCamera} from "../../public/js/hasCamera";
import {stopScanner} from "../../public/js/stopScanner";
import Clipboard from '@ryangjchandler/alpine-clipboard'
// import Quagga from '@ericblade/quagga2';
import Quagga from 'quagga';
import {createUpload} from "@mux/upchunk";
import Dropzone from 'dropzone';
Alpine.plugin(mask);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.plugin(Lightbox);
Alpine.plugin(Clipboard);
window.Alpine = Alpine;
window.Quagga = Quagga;
window.hasCamera = hasCamera;
window.stopScanner = stopScanner;
window.stopQuagga = stopQuagga;
window.createUpload = createUpload;
window.Dropzone = Dropzone;
Alpine.start();
